import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import FormSubHeading from "../components/FormSubHeading";
import "./CreateCase.css";
import { MultiSelect } from "primereact/multiselect";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  GENDERS,
  PHONE_CODES,
  CONDITIONS,
  INITIAL_HOLDER_FORM,
  INITIAL_PATIENT_FORM,
} from "../constants";
import { addCase, createCaseAndReassign } from "../services/medicalCases";
import { getHoldersMatchingCI, getPeopleMatchingCI } from "../services/people";
import { SelectButton } from "primereact/selectbutton";
import { Toast } from "primereact/toast";
import InputWithSuggestions from "../components/InputWithSuggestions";
// import RequirementModal from "./RequirementModal";
import RequirementModal from "./RequirementModalNew";
import {
  // useDiagnosisList,
  useSubsidiaries,
  useStateLocations,
  useClientList,
} from "../hooks/queries";
import VSieteDateInput from "../components/VSieteDateInput";
import { Dialog } from "primereact/dialog";
import { getDependency, getHoldersRMSCI } from "../services/rms";
import { Card } from "primereact/card";
import { useForm } from "@tanstack/react-form";
import { useStore } from "@tanstack/react-form";
import { useGetInsurance } from "../hooks/queries";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";

// @author @hector Added cached diagnosis and requirement list hooks
import { useDiagnosisListCached } from "../hooks/useDiagnosisListCached";
import {
  getCachedRequirementList,
  getClientList,
} from "../services/requirementCached";
import {
  clearRequirementsCache,
  getRequirementsByClient,
  clearListRequirementsCache,
} from "../services/requirementMedicalCenterCache";
// import { onFirebaseMessage } from "../firebaseMessaging";
// import { subscribeToTopic } from "../services/firebase";
// import NotificationPermissionBanner from "./NotificationPermissionBanner";
import "../firebaseConfig";
import { getDatabase, ref, onValue } from "firebase/database";
import RequirementDataView from "./Listing/RequirementDataView";
import { createSearchItemTemplate } from "../utils";
import PatientData from "./CreateCaseComponents/PatientData";

/**
 * @typedef API_Person Structure of the Person object returned by the API
 * @property {number} id
 * @property {string} ci
 * @property {string} name
 * @property {"M" | "F"} sex
 * @property {string} birthdate
 * @property {string} phone
 * @property {string} subsidiary
 * @property {boolean} is_holder
 * @property {string | null} holder
 */

/**
 * @typedef TableRequirement Structure of each requirement shown on the table
 * @property {number} requirementType
 * @property {string} requirementTypeLabel
 * @property {number} requirement
 * @property {string} requirementLabel
 * @property {number} medicalCenter
 * @property {string} medicalCenterLabel
 */

function FieldInfo({ field }) {
  return (
    <>
      {field.state.meta.isTouched && field.state.meta.errors.length ? (
        <small className="p-error">{field.state.meta.errors.join(",")}</small>
      ) : null}
      {/* {field.state.meta.isValidating ? 'Validating...' : null} */}
    </>
  );
}

// const INITIAL_PATIENT_FORM = {
//   ciType: "V",
//   ci: "",
//   name: "",
//   sex: null,
//   birthDate: "",
//   phoneCode: "58412",
//   phoneNumber: "",
//   diagnosis: null,
//   client: null,
//   subsidiary: null,
//   isHolder: true,
//   shouldCreatePatient: false,
//   minorId: "",
//   isMinor: false,
//   state: null,
// };

// const INITIAL_HOLDER_FORM = {
//   step: 1,
//   ciType: "V",
//   serviceId: "",
//   serviceNumber: "",
//   ci: "",
//   name: "",
//   sex: null,
//   birthDate: "",
//   birthDay: null,
//   birthMonth: null,
//   birthYear: null,
//   phoneCode: "58412",
//   phoneNumber: "",
//   shouldCreateHolder: false,
//   condition: "A",
//   optionalPhoneCode: "58412",
//   optionalPhoneNumber: "",
//   landlinePhoneNumber: "",
//   address: "",
//   prioritized: false,
//   patient: INITIAL_PATIENT_FORM,
//   state: null,
// };

/**
 * Formulario para crear un nuevo caso médico
 */
const FormComponent = () => {
  const form = useForm({
    initialValues: INITIAL_HOLDER_FORM,
    defaultValues: INITIAL_HOLDER_FORM,
    validators: {
      onMount: ({ value }) => {
        return {
          fields: {
            ci: value.ci ? undefined : "Cédula es requerida",
          },
        };
      },
      onChange: ({ value }) => {
        if (value.step === 1) {
          const errorMap = {
            fields: {
              sex: value.sex ? undefined : "Seleccione un sexo",
              name: value.name ? undefined : "Nombre completo es requerido",
              birthDate:
                value.birthDate.length === 10
                  ? undefined
                  : "Fecha de nacimiento es requerida",
              condition: value.condition ? undefined : "Condicion es requerida",
              phoneNumber: value.phoneNumber
                ? undefined
                : "Número de teléfono es requerido",
              "patient.ci": undefined,
              "patient.name": undefined,
              "patient.sex": undefined,
              "patient.birthDate": undefined,
            },
          };
          if (value.landlinePhoneNumber) {
            if (
              !/^(02|2)/.test(value.landlinePhoneNumber) ||
              (value.landlinePhoneNumber.length !== 10 &&
                value.landlinePhoneNumber.length !== 11)
            ) {
              errorMap.fields.landlinePhoneNumber =
                "El teléfono fijo es inválido";
            }
          }
          return errorMap;
        }
        if (!value.patient.isHolder && value.step === 2) {
          return {
            fields: {
              "patient.ci":
                value.patient.ci || value.patient.ciType === "M"
                  ? undefined
                  : "Cédula es requerida",
              "patient.sex": value.patient.sex
                ? undefined
                : "Seleccione un sexo",
              "patient.name": value.patient.name
                ? undefined
                : "Nombre completo es requerido",
              "patient.birthDate":
                value.patient.birthDate.length === 10
                  ? undefined
                  : "Fecha de nacimiento es requerida",
            },
          };
        }
        if (value.patient.isHolder && value.step === 2) {
          return {
            fields: {
              "patient.ci": undefined,
              "patient.name": undefined,
              "patient.sex": undefined,
              "patient.birthDate": undefined,
            },
          };
        }
        return {
          fields: {
            sex: value.sex ? undefined : "Seleccione un sexo",
            name: value.name ? undefined : "Nombre completo es requerido",
            birthDate:
              value.birthDate.length === 10
                ? undefined
                : "Fecha de nacimiento es requerida",
            condition: value.condition ? undefined : "Condicion es requerida",
          },
        };
      },
    },
    onSubmit: async ({ value }) => {
      // Do something with form data
      const { patient, ...holder } = value;

      newCaseMutation.mutate({
        patient: patient,
        holder: holder,
        serviceNumber: value.serviceNumber,
        prioritized: value.prioritized,
        state: value.state,
        address: value.address,
        medicalOrder: value.medicalOrder,
      });
    },
  });

  // Form state
  const [patientForm, setPatientForm] = useState(INITIAL_PATIENT_FORM);
  const [holderForm, setHolderForm] = useState(INITIAL_HOLDER_FORM);
  const [inputsLocked, setInputsLocked] = useState("");

  // const [holderLocked, setHolderLocked] = useState(false);
  // const [patientLocked, setPatientLocked] = useState(false);

  // Requirements
  const [showRequirementModal, setShowRequirementModal] = useState(false);
  const [requirementList, setRequirementList] = useState([]);
  const [editValues, setEditValues] = useState(null);
  const [selectedMedicalCenter, setSelectedMedicalCenter] = useState(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateCase, setDuplicateCase] = useState(false);

  // RMS
  const [rmsActive, setRmsActive] = useState(false);

  // const diagnosisQuery = useDiagnosisList();
  const diagnosisQuery = useDiagnosisListCached();

  // Get subsidiaries
  const subsidiariesQuery = useSubsidiaries();
  const stateLocationsQuery = useStateLocations();

  // Get holder by CI
  //   const holderQuery = useQuery({
  //   queryKey: ["holder", holderForm.ciType + holderForm.ci],
  //   queryFn: () => getHoldersMatchingCI(holderForm.ciType + holderForm.ci),
  //   enabled: holderForm.ci.length >= 4,
  // });
  const formStep = useStore(form.store, (state) => state.values.step);
  const holderCi = useStore(form.store, (state) => state.values.ci);
  const holderCiType = useStore(form.store, (state) => state.values.ciType);
  const holderName = useStore(form.store, (state) => state.values.name);
  const patientCi = useStore(form.store, (state) => state.values.patient.ci);
  const patientDiagnosis = useStore(
    form.store,
    (state) => state.values.patient.diagnosis
  );
  const patientName = useStore(
    form.store,
    (state) => state.values.patient.name
  );

  const subsidiaryPatient = useStore(
    form.store,
    (state) => state.values.patient.subsidiary
  );
  const statePatient = useStore(form.store, (state) => state.values.state);
  const patientCiType = useStore(
    form.store,
    (state) => state.values.patient.ciType
  );

  const patientClient = useStore(
    form.store,
    (state) => state.values.patient.client
  );
  const patientIsHolder = useStore(
    form.store,
    (state) => state.values.patient.isHolder
  );
  const selectCity = useStore(form.store, (state) => state.values.city);
  const formAddress = useStore(form.store, (state) => state.values.address);

  const stateForm = useStore(form.store, (state) => state.values.state);
  // Get holder by CI in rms
  const holderRMSQuery = useQuery({
    queryKey: ["holder-rms", holderCiType + holderCi],
    queryFn: () => getHoldersRMSCI(holderCiType, holderCi),
    // enabled: holderForm.ci.length >= 4,
    enabled: false,
  });

  const holderQuery = useQuery({
    queryKey: ["holder", holderCiType + holderCi],
    queryFn: () => getHoldersMatchingCI(holderCiType + holderCi),
    // enabled: holderCi?.length >= 4,
    enabled: false,
  });
  const [holderResult, setHolderResult] = useState([]);
  // Get patient by CI
  const patientQuery = useQuery({
    queryKey: ["patient", patientForm.ciType + patientForm.ci],
    queryFn: () => getPeopleMatchingCI(patientForm.ciType + patientForm.ci),
    enabled: patientForm.ci.length >= 4,
  });

  const { data: dependencies } = useQuery({
    queryKey: ["patient-dependency", patientForm.minorId],
    queryFn: () =>
      getDependency({ dniCode: holderCiType, dniNumber: holderCi }),
    enabled: !!holderCi,
  });

  const dependencyList =
    dependencies?.results
      ?.filter((person) => person.correl_aseg !== 0)
      .map((item) => ({
        ...item,
        name: `${item.nombre}`,
        code: item.correl_aseg,
      })) || [];
  const dependency = [
    ...dependencyList,
    { name: "Otro", code: "00" }, // Nuevo ítem
  ];

  const queryClient = useQueryClient();
  const useInsurance = useGetInsurance();
  const insurance = useInsurance?.data;
  const isVertice = insurance?.name === "Vértice Seguros";

  const clientList = useClientList();

  const [showOrderDialog, setShowOrderDialog] = useState(false);

  // useEffect(() => {
  // async function preloadRequirementCaches() {

  //   await getCachedRequirementList();
  //   const clientListResponse = await getClientList();
  //   const clientList = clientListResponse?.data || [];
  //   await Promise.all(
  //     clientList.map(client => getRequirementsByClient(client.id))
  //   );

  //   // Invalida el caché de requerimientos por cliente y centro
  //   queryClient.invalidateQueries({
  //     queryKey: ["cachedRequirementsByClientAndCenter"],
  //     exact: false, // Invalida todas las variantes de este queryKey
  //   });
  // }

  //   subscribeToTopic();

  //   preloadRequirementCaches();

  //   // Escucha notificaciones FCM
  //   onFirebaseMessage(async (payload) => {
  //     if (payload?.notification?.title === "BASE DE DATOS ACTUALIZADA") {
  //       console.log("Base de datos actualizada, limpiando caché y descargando requerimientos...");
  //       await clearRequirementsCache();
  //       await preloadRequirementCaches();
  //     }
  //   });

  //   // Escucha mensajes del service worker
  //   if ("serviceWorker" in navigator) {
  //     navigator.serviceWorker.addEventListener("message", async (event) => {
  //       if (event.data && event.data.type === "DB_UPDATED") {
  //         console.log("Recibido mensaje de actualización desde SW, limpiando caché de requerimientos...");
  //         await clearRequirementsCache();
  //         await preloadRequirementCaches();
  //       }
  //     });
  //   }

  // }, [queryClient]);

  useEffect(() => {
    async function preloadRequirementCaches() {
      await getCachedRequirementList();
      const clientListResponse = await getClientList();
      const clientList = clientListResponse?.data || [];
      await Promise.all(
        clientList.map((client) => getRequirementsByClient(client.id))
      );

      // Invalida el caché de requerimientos por cliente y centro
      queryClient.invalidateQueries({
        queryKey: ["cachedRequirementsByClientAndCenter"],
        exact: false, // Invalida todas las variantes de este queryKey
      });
    }

    const db = getDatabase();
    const versionRef = ref(db, "requirements_version/database_version");
    const listRequirementVersion = ref(
      db,
      "list_requirements_version/database_version"
    );

    const unsubscribe = onValue(versionRef, async (snapshot) => {
      // Obtén la versión local (puedes guardarla en localStorage o en un estado)
      let localVersion = localStorage.getItem("requirement_version_id");
      const remoteVersion = String(snapshot.val());

      if (remoteVersion && remoteVersion !== localVersion) {
        // console.log("Nueva versión de requerimientos detectada:", remoteVersion);
        // Actualiza la versión local
        localStorage.setItem("requirement_version_id", remoteVersion);
        // Ejecuta tu lógica de actualización
        await clearRequirementsCache();
        await preloadRequirementCaches();
      }
    });

    const unsubscribeList = onValue(
      listRequirementVersion,
      async (snapshot) => {
        const remoteVersion = String(snapshot.val());
        const localVersion = localStorage.getItem(
          "list_requirement_version_id"
        );

        if (remoteVersion && remoteVersion !== localVersion) {
          // console.log("Nueva versión de requerimientos detectada:", remoteVersion);
          // Actualiza la versión local
          localStorage.setItem("list_requirement_version_id", remoteVersion);
          // Ejecuta tu lógica de actualización
          console.log("remoteVersion", remoteVersion);
          await clearListRequirementsCache();
          await preloadRequirementCaches();
        }
      }
    );

    return () => {
      // Limpia el listener al desmontar el componente
      unsubscribe();
      unsubscribeList();
    };
  }, [queryClient]);

  // Mutation for new case
  const newCaseMutation = useMutation({
    mutationFn: ({
      patient,
      holder,
      serviceNumber,
      prioritized,
      state = null,
      address = "",
      medicalOrder = null,
    }) => {
      if (requirementList.some((r) => r.subAdminMedicalCenter !== null)) {
        return createCaseAndReassign({
          patient: patient,
          holder: holder,
          requirements: requirementList,
          duplicate: duplicateCase,
          serviceNumber,
          prioritized,
          state,
          address,
          medicalOrder,
        });
      } else {
        return addCase({
          patient: patient,
          holder: holder,
          requirements: requirementList,
          duplicate: duplicateCase,
          serviceNumber,
          prioritized,
          state,
          address,
          city: selectCity,
          medicalOrder,
        });
      }
    },
    onSuccess: ({ type, message, code, data }) => {
      if (type === "error") {
        if (Array.isArray(code) && code.includes("case_exists")) {
          setShowOrderDialog(false);
          handleDuplicateCase();
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: message,
          });
        }
      } else {
        queryClient.invalidateQueries({
          queryKey: ["medicalCases"],
        });
        const caseId = data?.id || data?.caseId || "no disponible";

        toast.current.show({
          severity: "success",
          //summary: "Éxito",
          content: (
            <div>
              <div style={{ 
                fontSize: '20px', 
                fontWeight: '600', 
                color: '#14532d' 
              }}>
                🎉 ¡Caso registrado con éxito!
              </div>
              <div style={{ 
                fontSize: '18px', 
                marginTop: '4px' 
              }}>
                El caso se guardó correctamente.
              </div>
              <a 
                href={`/casos/${caseId}`}
                style={{ 
                  display: 'inline-block',
                  marginTop: '8px',
                  padding: '6px 12px',
                  backgroundColor: '#0d9668',
                  color: '#fff',
                  textDecoration: 'none',
                  borderRadius: '4px',
                  fontWeight: '600',
                  fontSize: '15px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
              >
                🔍 Ver caso #{caseId}
              </a>
            </div>
          ),
          life: 12000,
          style: { 
            width: 'auto', 
            minWidth: '300px', 
            backgroundColor: '#f0f9f5', 
            color: '#14532d' 
          },
          contentStyle: { 
            color: '#14532d' 
          }
        });
        // setPatientForm(INITIAL_PATIENT_FORM);
        // setHolderForm(INITIAL_HOLDER_FORM);
        // setInputsLocked("");

        setRequirementList([]);
        setShowOrderDialog(false);
        setSelectedMedicalCenter(null);
        setDuplicateCase(false);
        form.reset();
        form.onChange();
      }
    },
  });

  const disabledSave = isVertice
    ? !selectCity ||
      !patientDiagnosis ||
      !requirementList.length ||
      !formAddress
    : newCaseMutation.isPending || !patientDiagnosis || !requirementList.length;

  // const getDependencyMutation = useMutation({
  //     mutationFn: getDependency,
  //     onSuccess: (data) => {

  //       if (!data.results) {
  //         setDependency([]);
  //         setHolderList({data: []});
  //         return
  //       }
  //       const dependency = data.results.filter((dep)=> dep.correl_aseg !==0).map((dep) => {
  //         return {name: dep.nombre, code: dep.correl_aseg}
  //       });
  //       const holder = data.results.filter((dep)=> dep.correl_aseg === 0);
  //       setDependency(dependency);
  //       setHolderList({data: holder});
  //     },
  // });

  // Fetch dependency data on component mount
  // useEffect(() => {
  //   console.log(patientForm.ciType, "patientForm.ciType");
  //   if(holderForm.ci.length >= 5){
  //     getDependencyMutation.mutate({dniCode: holderForm.ciType, dniNumber: holderForm.ci});
  //   }
  // }, [holderForm.ciType, holderForm.ci]);
  // Validate fields being set so requirement can be added
  const canAddRequirement =
    (patientForm.isHolder && holderForm.ci) ||
    Object.keys(patientForm).every((key) => {
      return patientForm[key] !== null && patientForm !== "";
    });

  // Validate fields being set so case can be saved
  const canSaveCase = canAddRequirement && requirementList.length > 0;

  // Form message toast
  const toast = useRef(null);

  // Patient and holder name inputs
  const holderNameRef = useRef(null);
  // const patientNameRef = useRef(null);

  // Search overlays
  const holderSearchRef = useRef(null);
  // const patientSearchRef = useRef(null);

  /**
   * Key up event for holder search
   * @param {KeyboardEvent} e
   */
  const onHolderSearchEnter = (e) => {
    if (e.key === "Escape") {
      holderSearchRef.current.hide();
    }
    if (e.key === "Enter") {
      // const ci = holderForm.ciType + holderForm.ci;
      // if (
      //   !holderQuery.data ||
      //   !holderQuery.data.length ||
      //   ci !== holderQuery.data[0].ci
      // ) {
      //   setHolderForm({ ...holderForm, shouldCreateHolder: true });
      //   holderSearchRef.current.hide();
      //   // Wait 50ms for holderNameRef to be set
      //   setTimeout(() => {
      //     holderNameRef.current.focus();
      //   }, 50);
      //   return;
      // }
      // selectHolder(holderQuery.data[0]);
    }
  };

  /**
   * Key up event for patient search
   * @param {KeyboardEvent} e
   */
  // const onPatientSearchEnter = (e) => {
  //   if (patientSelected) return;

  //   if (e.key === "Escape") {
  //     patientSearchRef.current.hide();
  //   }
  //   if (e.key === "Enter") {
  //     if (!patientQuery.data || !patientQuery.data.length) {
  //       setPatientForm({ ...patientForm, shouldCreatePatient: true });
  //       patientSearchRef.current.hide();
  //       patientNameRef.current.focus();
  //     } else {
  //       selectPatient(patientQuery.data[0]);
  //     }
  //   }
  // };

  /**
   * Sets form state from a selected patient
   * @param {API_Person} holder
   */
  const selectHolder = (holder) => {
    console.log(holder);
    setHolderForm({
      ciType: holderForm.ciType,
      ci: holderForm.ci,
      // sex: holder.sex,
      // birthDate: holder.birthdate.split("-").reverse().join("/"),
      name: holder.nombre,
      // phoneCode: holder.phone.slice(0, 5),
      // phoneNumber: holder.phone.slice(5),
      shouldCreateHolder: false,
    });
    setPatientForm({ ...patientForm, isHolder: true });
    // setHolderLocked(true);
    holderSearchRef.current.hide();
  };

  /**
   * Sets form state from a selected patient
   * @param {API_Person} patient
   */
  // const selectPatient = (patient) => {
  //   console.log(patient, "selectPatient");
  //   if(patient.ciType === "M"){
  //     setPatientForm({
  //       ...patientForm,
  //       name: patient.name,
  //     });
  //   }
  //   setPatientForm({
  //     ...patientForm,
  //     ciType: patient.ci.slice(0, 1),
  //     ci: patient.ci.slice(1),
  //     name: patient.name,
  //     sex: patient.sex,
  //     birthDate: patient.birthdate.split("-").reverse().join("/"),
  //     phoneCode: patient.phone.slice(0, 5),
  //     phoneNumber: patient.phone.slice(5),
  //     subsidiary: patient.subsidiary,
  //     diagnosis: null,
  //     isHolder: false,
  //     shouldCreatePatient: false,
  //   });
  //   // setPatientLocked(true);
  //   setPatientSelected(true);
  //   patientSearchRef.current.hide();
  // };

  const handleDuplicateCase = () => {
    setShowDuplicateModal(true);
  };

  const confirmDuplicateCase = () => {
    setShowDuplicateModal(false);
    setDuplicateCase(true);
    newCaseMutation.mutate();
  };

  const duplicateModalFooter = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between", // Separa los botones en extremos opuestos
        width: "100%",
      }}
    >
      <Button
        label="Si"
        icon="pi pi-check"
        onClick={confirmDuplicateCase}
        autoFocus
      />
      <Button
        label="No"
        icon="pi pi-times"
        onClick={() => setShowDuplicateModal(false)}
        className="p-button-text p-button-danger"
        style={{
          background: "red",
          color: "white",
        }}
      />
    </div>
  );

  const duplicateModalContent = (
    <div>
      <p>¿Está seguro de que desea duplicar este caso?</p>
      {patientForm.isHolder ? (
        <p>
          <strong>Paciente:</strong> {holderForm.name}
        </p>
      ) : (
        <p>
          <strong>Paciente:</strong> {patientForm.name}
        </p>
      )}
      <ul>
        {requirementList.map((req, index) => (
          <li key={index}>
            {req.requirementTypeLabel} - {req.requirementLabel}
          </li>
        ))}
      </ul>
    </div>
  );

  const search = async (e) => {
    if (e.query && /\D/.test(e.query)) {
      form.setFieldValue("ci", e.query.replace(/\D/g, ""));
      e.query = e.query.replace(/\D/g, "");
      search(e);
      return;
    }
    const response = await getHoldersMatchingCI(holderCiType + e.query);
    // const response = await getHoldersRMSCI(holderCiType, e.query);
    // const changeHolder = response.map((item) => ({
    //   ...item,
    //   label: `${item.cedrif_aseg} - ${item.nombre}`,
    //   value: item.cedrif_aseg,
    // }));
    const changeHolder = response.map((item) => ({
      ...item,
      label: `${item.ci} - ${item.name}`,
      value: item.ci.replace(/\D/g, ""),
    }));
    setHolderResult(changeHolder);
    console.log(inputsLocked);
  };

  const handlePhonePaste = (e, codeField, numberField) => {
    const text = e.clipboardData.getData("text/plain");
    const newText = text.replace(/\D/g, "");
    if (newText.length === 11) {
      // Incluye el 0
      const phoneCode = newText.slice(0, 4);
      const result = PHONE_CODES.find((item) => {
        return item.value === phoneCode || item.label === phoneCode;
      });

      if (result) {
        form.setFieldValue(codeField, result.value);
        form.setFieldValue(numberField, newText.slice(4));
      }
    } else if (newText.length === 10) {
      // No incluye el 0
      const phoneCode = "0" + newText.slice(0, 3);
      const result = PHONE_CODES.find((item) => {
        return item.value === phoneCode || item.label === phoneCode;
      });

      if (result) {
        form.setFieldValue(codeField, result.value);
        form.setFieldValue(numberField, newText.slice(3));
      }
    } else if (newText.length === 12) {
      // Empieza por 58
      const phoneCode = "0" + newText.slice(2, 5);
      const result = PHONE_CODES.find((item) => {
        return item.value === phoneCode || item.label === phoneCode;
      });

      if (result) {
        form.setFieldValue(codeField, result.value);
        form.setFieldValue(numberField, newText.slice(5));
      }
    }
    e.preventDefault();
  };

  return (
    <div className="p-fluid">
      <Toast ref={toast} position="top-center" />
      {/* <NotificationPermissionBanner /> */}
      <form>
        {(formStep === 2 || formStep === 3) && (
          <Card title="" className="mb-2 card-step">
            {/* <FormSubHeading title="Titular" /> */}
            <div className="ml-2 mr-2">
              <span className="text-xl font-bold"> Titular:</span>
              <span>
                {" "}
                {holderCiType}-{holderCi} {holderName}{" "}
              </span>
            </div>
            {formStep === 3 && patientIsHolder && (
              <div className="ml-2 mr-2">
                <span className="text-xl font-bold"> Paciente:</span>
                <span>
                  {" "}
                  {holderCiType}-{holderCi} {holderName}{" "}
                </span>
              </div>
            )}
            {formStep === 3 && !patientIsHolder && (
              <div className="ml-2 mr-2">
                <span className="text-xl font-bold"> Paciente:</span>
                <span>
                  {" "}
                  {patientCiType}-{patientCi} {patientName}{" "}
                </span>
              </div>
            )}
          </Card>
        )}

        {/* DATOS DEL TITULAR */}
        {formStep === 1 && (
          <div>
            {/* SELECCIÓN DE FILIAL */}
            {(!isVertice || (isVertice && clientList.data?.length > 1)) && (
              <>
                <FormSubHeading title={isVertice ? "Colectivo" : "Filial"} />
                <form.Field name="patient.subsidiary">
                  {(field) => (
                    <div className="p-field">
                      <label htmlFor="subsidiary">
                        {isVertice ? "Colectivo" : "Filial"}
                      </label>
                      <Dropdown
                        id="subsidiary"
                        name="subsidiary"
                        options={subsidiariesQuery.data ?? []}
                        value={field.state.value}
                        onChange={(e) => {
                          field.handleChange(e.value);
                          const subsidiary = subsidiariesQuery.data.find(
                            (subsidiary) => subsidiary.id === e.value
                          );
                          form.setFieldValue(
                            "patient.client",
                            subsidiary?.company_client ?? null
                          );
                          setRmsActive(
                            subsidiary?.is_client_active_rms ?? false
                          );
                        }}
                        optionLabel="name"
                        optionValue="id"
                        placeholder={
                          isVertice
                            ? "Seleccionar colectivo"
                            : "Seleccionar filial"
                        }
                        filter
                        filterPlaceholder="Buscar filial"
                        disabled={
                          patientQuery.isLoading || subsidiariesQuery.isLoading
                        }
                        loading={subsidiariesQuery.isLoading}
                      />
                    </div>
                  )}
                </form.Field>
              </>
            )}

            {/* {insurance?.name === "Vértice Seguros" && (
              <div className="p-field">
                <label htmlFor="serviceNumber">Nro. de caso</label>
                <form.Field name="serviceNumber">
                  {(field) => (
                    <InputText
                      id="serviceNumber"
                      name="serviceNumber"
                      value={field.state.value}
                      onChange={(e) => field.handleChange(e.target.value)}
                      invalid={field.state.meta.errors.length > 0}
                    />
                  )}
                </form.Field>
              </div>
            )} */}
            <FormSubHeading title="Datos del Titular" />

            <div className="p-field">
              <label htmlFor="holderCi">Cédula</label>
              <div className="field-with-select">
                <form.Field name="ciType">
                  {(field) => (
                    <Dropdown
                      id={"holder" + field.name}
                      name={"holder" + field.name}
                      options={["V", "E"]}
                      placeholder="Tipo"
                      value={field.state.value}
                      onChange={(e) => field.handleChange(e.value)}
                      required
                    />
                  )}
                </form.Field>

                <form.Field name="ci">
                  {(field) => (
                    <InputWithSuggestions
                      inputName={field.name}
                      inputValue={field.state.value}
                      keyfilter="pint"
                      maxLength={9}
                      onCompleteMethod={search}
                      suggestions={holderResult}
                      onTextChange={(e) => {
                        if (e.value && e.value.hasOwnProperty("value")) {
                          field.handleChange(e.value.value);
                          // form.setFieldValue("name", e.value.nombre);
                          form.setFieldValue("name", e.value.name);
                          form.setFieldValue("sex", e.value.sex);
                          form.setFieldValue(
                            "birthDate",
                            e.value.birthdate.split("-").reverse().join("/")
                          );
                          form.setFieldValue("condition", e.value.condition);
                          // form.setFieldValue("phoneNumber", e.value)
                          const phone = e.value.phone;
                          form.setFieldValue("phoneCode", phone.slice(0, 5));
                          form.setFieldValue("phoneNumber", phone.slice(5));
                          // phone
                          form.validateSync();

                          return;
                        }
                        field.handleChange(e.value);
                      }}
                      query={holderRMSQuery}
                      notFoundBtnLabel="Crear registro de asegurado"
                      notFoundBtnClick={() => {}}
                      itemTemplate={createSearchItemTemplate(selectHolder)}
                      overlayRef={holderSearchRef}
                      onSearchEnter={onHolderSearchEnter}
                    />
                  )}
                </form.Field>
              </div>
            </div>

            <div className="p-field">
              {/* Holder personal data */}
              <form.Field
                name="name"
                children={(field) => (
                  <div className="p-field mt-2">
                    <label htmlFor="holderName">Nombre completo</label>
                    <InputText
                      id="holderName"
                      name="holderName"
                      value={field.state.value}
                      onChange={(e) => field.handleChange(e.target.value)}
                      // setHolderForm({ ...holderForm, name: e.target.value })
                      invalid={field.state.meta.errors.length > 0}
                      disabled={holderQuery.isLoading}
                      ref={holderNameRef}
                    />
                    <FieldInfo field={field} />
                  </div>
                )}
              />

              {/* SEXO */}
              <form.Field
                name="sex"
                children={(field) => (
                  <div className="p-field">
                    <label htmlFor="holderSex">Sexo</label>
                    <SelectButton
                      id="holderSex"
                      name="holderSex"
                      value={field.state.value}
                      onChange={(e) => field.handleChange(e.target.value)}
                      // setHolderForm({ ...holderForm, sex: e.value })
                      options={GENDERS}
                      disabled={holderQuery.isLoading}
                      invalid={field.state.meta.errors.length > 0}
                    />
                    <FieldInfo field={field} />
                  </div>
                )}
              />

              <form.Field name="birthDate">
                {(field) => (
                  <div className="p-field">
                    <span>Fecha de nacimiento</span>
                    <VSieteDateInput
                      name="holderBirthdate"
                      value={field.state.value}
                      setValue={(value) => field.handleChange(value)}
                      // setHolderForm({ ...holderForm, birthDate: value })
                      disabled={holderQuery.isLoading}
                      invalid={field.state.meta.errors.length > 0}
                    />
                  </div>
                )}
              </form.Field>

              <form.Field name="condition">
                {(field) => (
                  <div className="p-field">
                    <label htmlFor="holderCondition">Condición</label>
                    <SelectButton
                      id="holderCondition"
                      name="holderCondition"
                      className="select-sex"
                      value={field.state.value}
                      onChange={(e) => field.handleChange(e.target.value)}
                      options={CONDITIONS}
                      invalid={field.state.meta.errors.length > 0}
                    />
                  </div>
                )}
              </form.Field>

              <div className="p-field">
                <label htmlFor="phoneNumber">Número de teléfono</label>
                <div className="field-with-select">
                  <form.Field name="phoneCode">
                    {(field) => (
                      <Dropdown
                        id="phoneCode"
                        name="phoneCode"
                        options={PHONE_CODES}
                        placeholder="Código"
                        value={field.state.value}
                        onChange={(e) => field.handleChange(e.value)}
                        disabled={patientQuery.isLoading}
                      />
                    )}
                  </form.Field>

                  <form.Field name="phoneNumber">
                    {(field) => (
                      <InputText
                        id="phoneNumber"
                        name="phoneNumber"
                        inputMode="numeric"
                        keyfilter="pint"
                        maxLength={7}
                        value={field.state.value}
                        onChange={(e) => field.handleChange(e.target.value)}
                        onPaste={(e) =>
                          handlePhonePaste(e, "phoneCode", "phoneNumber")
                        }
                        disabled={patientQuery.isLoading}
                      />
                    )}
                  </form.Field>
                </div>
              </div>

              <div className="p-field">
                <label htmlFor="optionalPhoneNumber">
                  Número de teléfono (opcional)
                </label>
                <div className="field-with-select">
                  <form.Field name="optionalPhoneCode">
                    {(field) => (
                      <Dropdown
                        id="phoneCode"
                        name="phoneCode"
                        options={PHONE_CODES}
                        placeholder="Código"
                        value={field.state.value}
                        onChange={(e) => field.handleChange(e.value)}
                        disabled={patientQuery.isLoading}
                      />
                    )}
                  </form.Field>

                  <form.Field name="optionalPhoneNumber">
                    {(field) => (
                      <InputText
                        id="optionalPhoneNumber"
                        name="optionalPhoneNumber"
                        inputMode="numeric"
                        keyfilter="pint"
                        maxLength={7}
                        value={field.state.value}
                        onChange={(e) => field.handleChange(e.target.value)}
                        onPaste={(e) =>
                          handlePhonePaste(
                            e,
                            "optionalPhoneCode",
                            "optionalPhoneNumber"
                          )
                        }
                        disabled={patientQuery.isLoading}
                      />
                    )}
                  </form.Field>
                </div>
              </div>

              <div className="p-field">
                <label htmlFor="landlinePhoneNumber">
                  Número de teléfono fijo (opcional)
                </label>
                <form.Field name="landlinePhoneNumber">
                  {(field) => (
                    <>
                      <InputText
                        id="landlinePhoneNumber"
                        name="landlinePhoneNumber"
                        inputMode="numeric"
                        keyfilter="pint"
                        maxLength={11}
                        value={field.state.value}
                        onChange={(e) => field.handleChange(e.target.value)}
                        invalid={field.state.meta.errors.length > 0}
                        onPaste={(e) => {
                          // Remove non-numeric values
                          const text = e.clipboardData.getData("text/plain");
                          const newText = text.replace(/\D/g, "");
                          e.preventDefault();
                          field.handleChange(newText);
                        }}
                      />
                      <FieldInfo field={field} />
                    </>
                  )}
                </form.Field>
              </div>
            </div>
          </div>
        )}

        {/* DATOS DEL PACIENTE */}
        {formStep === 2 && (
          <>
            {/* DATOS DEL PACIENTE */}
            <form.Field name="patient.isHolder">
              {(field) => (
                <div className="flex flex-row align-items-center gap-3 pt-2 mb-2">
                  <span>¿El titular es el paciente?</span>
                  <SelectButton
                    value={field.state.value}
                    onChange={(e) => field.handleChange(e.target.value)}
                    // setPatientForm({ ...patientForm, isHolder: e.value })
                    options={[
                      { label: "Si", value: true },
                      { label: "No", value: false },
                    ]}
                    disabled={patientQuery.isLoading || holderQuery.isLoading}
                    allowEmpty={false}
                  />
                </div>
              )}
            </form.Field>
            {!patientIsHolder && (
              <PatientData
                form={form}
                holderQuery={holderQuery}
                onHolderSearchEnter={onHolderSearchEnter}
                selectHolder={selectHolder}
                dependency={dependency}
                isRmsActive={rmsActive}
              />
            )}
          </>
        )}

        {formStep === 3 && (
          <div>
            {/* SELECCIÓN DE DIAGNÓSTICO */}
            <FormSubHeading title="Diagnóstico" />
            <form.Field name="patient.diagnosis">
              {(field) => (
                <div className="p-field">
                  <label htmlFor="diagnosis">Diagnóstico</label>
                  <MultiSelect
                    id="diagnosis"
                    name="diagnosis"
                    value={field.state.value}
                    onChange={(e) => field.handleChange(e.value)}
                    options={diagnosisQuery.data ?? []}
                    optionValue="id"
                    optionLabel="name"
                    placeholder="Seleccionar diagnóstico"
                    filter
                    loading={diagnosisQuery.isLoading}
                    disabled={diagnosisQuery.isLoading}
                    virtualScrollerOptions={{
                      itemSize: 48,
                      style: { width: "650px" },
                    }}
                    showSelectAll={false}
                  />
                </div>
              )}
            </form.Field>

            <FormSubHeading title="Caso Priorizado" />
            <form.Field name="prioritized">
              {(field) => (
                <div className="p-field flex gap-2 align-items-center mb-2">
                  <Checkbox
                    inputId="prioritized"
                    name="prioritized"
                    checked={field.state.value}
                    onChange={(e) => field.handleChange(e.checked)}
                  />
                  <label htmlFor="prioritized">Priorizar caso</label>
                </div>
              )}
            </form.Field>

            {isVertice && (
              <>
                <FormSubHeading title="Estado" />
                <form.Field name="state">
                  {(field) => (
                    <div className="p-field">
                      <label htmlFor="state">Estado</label>
                      <Dropdown
                        id="state"
                        name="state"
                        options={stateLocationsQuery.data ?? []}
                        value={field.state.value}
                        onChange={(e) => {
                          field.handleChange(e.value);
                          if (isVertice && clientList.data?.length === 1) {
                            form.setFieldValue(
                              "patient.client",
                              subsidiariesQuery.data?.[0].company_client
                            );
                            form.setFieldValue(
                              "patient.subsidiary",
                              subsidiariesQuery.data?.[0].id
                            );
                          }
                          form.setFieldValue("city", null);
                        }}
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Seleccionar estado"
                        filter
                        disabled={stateLocationsQuery.isLoading}
                        loading={stateLocationsQuery.isLoading}
                      />
                    </div>
                  )}
                </form.Field>
                <form.Field name="city">
                  {(field) => (
                    <div className="p-field">
                      <label htmlFor="city">Ciudad</label>
                      <Dropdown
                        id="city"
                        name="city"
                        options={
                          statePatient
                            ? stateLocationsQuery.data?.find(
                                (state) => state.id === statePatient
                              )?.cities ?? []
                            : []
                        }
                        value={field.state.value}
                        onChange={(e) => field.handleChange(e.value)}
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Seleccionar ciudad"
                        filter
                        disabled={
                          !statePatient || stateLocationsQuery.isLoading
                        }
                        loading={stateLocationsQuery.isLoading}
                      />
                    </div>
                  )}
                </form.Field>
                <form.Field name="address">
                  {(field) => (
                    <div className="p-field">
                      <label htmlFor="address">Dirección (requerida)</label>
                      <InputTextarea
                        id="address"
                        name="address"
                        placeholder="Ejemplo: municipio, ciudad, calle, nombre del edificio, # de piso, # de casa"
                        value={field.state.value}
                        onChange={(e) => field.handleChange(e.target.value)}
                        style={{ resize: "vertical" }}
                        rows={2}
                      />
                    </div>
                  )}
                </form.Field>
              </>
            )}

            <>
              {/* TABLA DE REQUERIMIENTOS */}
              <FormSubHeading title="Requerimientos" />
              <RequirementDataView
                requirements={requirementList}
                setRequirementList={setRequirementList}
                setCenterSelected={setSelectedMedicalCenter}
              />
            </>

            <Button
              id="btn-add-requirement"
              type="button"
              icon="pi pi-plus"
              tooltip={
                insurance?.name === "Vértice Seguros"
                  ? "Seleccione Estado"
                  : "Seleccione Filial"
              }
              label="Añadir requerimiento"
              className="mt-2 mb-2"
              severity="info"
              tooltipOptions={{ showOnDisabled: true, position: "top" }}
              disabled={subsidiaryPatient == null || statePatient === null}
              loading={newCaseMutation.isPending}
              onClick={() => {
                setEditValues(null);
                setShowRequirementModal(true);
              }}
            />
          </div>
        )}

        {/* BOTONES STEP */}
        {formStep === 1 && (
          <form.Subscribe
            selector={(state) => [
              state.canSubmit,
              state.isSubmitting,
              state.errorMap,
            ]}
            children={([canSubmit, isSubmitting, errors]) => (
              <div className="flex gap-2 justify-between mt-2">
                <Button
                  type="button"
                  icon="pi pi-arrow-left"
                  label="Volver"
                  className=""
                  severity="secondary"
                  raised
                  disabled={formStep === 1}
                  onClick={() => {}}
                />

                <Button
                  type="button"
                  icon="pi pi-arrow-right"
                  label="Siguiente"
                  tooltip="Complete los datos"
                  tooltipOptions={{ position: "top" }}
                  className=""
                  iconPos="right"
                  disabled={!canSubmit}
                  onClick={() => {
                    form.setFieldValue("step", formStep + 1);
                    form.validateSync();
                  }}
                />
              </div>
            )}
          />
        )}
        {formStep === 2 && (
          <form.Subscribe
            selector={(state) => [state.canSubmit, state.isSubmitting]}
            children={([canSubmit, isSubmitting, errors]) => (
              <div className="flex gap-2 justify-between mt-2">
                <Button
                  type="button"
                  icon="pi pi-arrow-left"
                  label="Volver"
                  className=""
                  severity="secondary"
                  raised
                  disabled={formStep === 1}
                  onClick={() => {
                    form.setFieldValue("step", formStep - 1);
                    form.validateSync();
                  }}
                />

                <Button
                  type="button"
                  icon="pi pi-arrow-right"
                  label="Siguiente"
                  tooltip="Complete los datos"
                  tooltipOptions={{ position: "top" }}
                  className=""
                  iconPos="right"
                  disabled={!canSubmit}
                  onClick={() => {
                    form.setFieldValue("step", formStep + 1);
                    form.validateSync();
                  }}
                />
              </div>
            )}
          />
        )}

        {formStep === 3 && (
          <form.Subscribe
            selector={(state) => [state.canSubmit, state.isSubmitting]}
            children={([canSubmit, isSubmitting, errors]) => (
              <div className="flex gap-2 justify-between mt-2">
                <Button
                  type="button"
                  icon="pi pi-arrow-left"
                  label="Volver"
                  className=""
                  severity="secondary"
                  raised
                  disabled={formStep === 1}
                  onClick={() => {
                    form.setFieldValue("step", formStep - 1);
                    form.validateSync();
                  }}
                />

                <Button
                  id="btn-save-case"
                  type="button"
                  icon="pi pi-save"
                  label="Guardar Caso"
                  tooltip="Complete los datos"
                  tooltipOptions={{ position: "top" }}
                  className=""
                  iconPos="right"
                  disabled={!canSubmit || disabledSave}
                  onClick={() => setShowOrderDialog(true)}
                />
              </div>
            )}
          />
        )}
      </form>

      {!!canSaveCase && (
        <Button
          type="button"
          icon="pi pi-save"
          label="Guardar caso"
          className="mt-4"
          severity="success"
          loading={newCaseMutation.isPending}
          disabled={newCaseMutation.isPending}
          onClick={() => newCaseMutation.mutate()}
        />
      )}

      {/* MODAL DE REQUERIMIENTOS */}
      {/* <RequirementModal
        showModal={showRequirementModal}
        onHide={() => {
          if (!showRequirementModal) return;
          setEditValues(null);
          setShowRequirementModal(false);
        }}
        state={stateForm}
        setRequirementList={setRequirementList}
        setInputsLocked={setInputsLocked}
        initialValues={editValues}
        patientClient={patientClient}
        centerSelected={selectedMedicalCenter}
        setCenterSelected={setSelectedMedicalCenter}
      /> */}
      {/* MODAL DE REQUERIMIENTOS */}
      <RequirementModal
        showModal={showRequirementModal}
        onHide={() => {
          if (!showRequirementModal) return;
          setEditValues(null);
          setShowRequirementModal(false);
        }}
        state={stateForm}
        setRequirementList={setRequirementList}
        setInputsLocked={setInputsLocked}
        initialValues={editValues}
        patientClient={patientClient}
        centerSelected={selectedMedicalCenter}
        setCenterSelected={setSelectedMedicalCenter}
      />

      {/* MODAL DE CONFIRMACIÓN DE DUPLICADO */}
      <Dialog
        header="Confirmar duplicado"
        visible={showDuplicateModal}
        style={{ width: "50vw" }}
        footer={duplicateModalFooter}
        onHide={() => setShowDuplicateModal(false)}
      >
        {duplicateModalContent}
      </Dialog>

      {/* Modal de orden médica */}
      <MedicalOrderDialog
        form={form}
        show={showOrderDialog}
        onHide={() => {
          if (showOrderDialog && !newCaseMutation.isPending)
            setShowOrderDialog(false);
        }}
        loading={newCaseMutation.isPending}
      />
    </div>
  );
};

/**
 *
 * @param {object} props
 * @param {import("@tanstack/react-form").ReactFormExtendedApi} props.form
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 * @param {boolean} props.loading
 */
function MedicalOrderDialog({ form, show, onHide, loading }) {
  return (
    <Dialog
      visible={show}
      onHide={onHide}
      header="Orden Médica"
      draggable={false}
      className="md:w-4"
    >
      <div className="p-fluid">
        <p className="text-lg text-center mt-0">
          <b>¿Desea cargar una orden médica?</b>
        </p>
        <form.Field name="medicalOrder">
          {(field) => (
            <div className="p-field">
              <label htmlFor="medicalOrder">Orden médica (opcional)</label>
              <input
                type="file"
                id="medicalOrder"
                name="medicalOrder"
                onChange={(e) => field.handleChange(e.target.files?.[0])}
                className="w-full surface-100 p-2 cursor-pointer p-component p-input border-round-md border-1 border-200 mb-2 mt-1"
              />
            </div>
          )}
        </form.Field>
        <Button
          id="btn-confirm-save-case"
          type="button"
          icon="pi pi-save"
          label="Guardar Caso"
          className=""
          iconPos="right"
          onClick={() => {
            form.handleSubmit();
          }}
          loading={loading}
          disabled={loading}
        />
      </div>
    </Dialog>
  );
}

export default FormComponent;
